import { FC, ReactNode } from 'react'
import './index.less'
import { TShirtSize, Display } from '../../util/types'
import { marginClasses } from '../../util/less-util'

export interface PerSpacerProps {
  children?: ReactNode
  m?: TShirtSize
  mx?: TShirtSize
  my?: TShirtSize
  mt?: TShirtSize
  mr?: TShirtSize
  mb?: TShirtSize
  ml?: TShirtSize
  display?: Display
  className?: string
  testid?: string
}

const PerSpacer: FC<PerSpacerProps> = ({ children, m, mb, mt, ml, mr, mx, my, display, className, testid }) => {
  const base = 'per-spacer'
  const modifiers = marginClasses(m, mb, mt, ml, mr, mx, my, base)

  if (display) {
    modifiers.push(`${base}--display-${display}`)
  }
  if (className) {
    modifiers.push(className)
  }

  return (
    <div data-testid={testid} className={base + ' ' + modifiers.join(' ')}>
      {children}
    </div>
  )
}

export default PerSpacer
